import { render, staticRenderFns } from "./FormRole.vue?vue&type=template&id=2f4a3004&"
import script from "./FormRole.vue?vue&type=script&lang=js&"
export * from "./FormRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports